import { ChevronRightIcon } from '@heroicons/vue/outline'
import { reactive, readonly } from 'vue'
import roleTypes from '@/contracts/RoleTypes'

const state = reactive({
  items: [],
})

const methods = {
  init(user) {
    state.items = [
      // {
      //   name: 'My Dashboard',
      //   icon: {
      //     name: 'chart-simple',
      //     class: 'text-white fa-fw',
      //   },
      //   current: true,
      //   hidden: !user.methods.hasAnyRoles([
      //     roleTypes.Super,
      //     roleTypes.Admin,
      //     roleTypes.Provider,
      //     roleTypes.Customer,
      //   ]),
      //   items: [
      //     {
      //       name: 'Dashboard',
      //       to: { name: 'AdminDashboard' },
      //       icon: ChevronRightIcon,
      //       current: false,
      //       hidden: !user.methods.hasAnyRoles([
      //         roleTypes.Super,
      //         roleTypes.Admin,
      //       ]),
      //     },
      //     {
      //       name: 'Dashboard',
      //       to: { name: 'UserDashboard' },
      //       icon: ChevronRightIcon,
      //       current: false,
      //       hidden: !user.methods.hasAnyRoles([roleTypes.Provider, roleTypes.Customer]),
      //     },
      //   ],
      // },
      {
        name: 'Recoveries',
        icon: {
          name: 'truck',
          class: 'fa-flip-horizontal text-white fa-fw',
        },
        hidden: !user.methods.hasAnyRoles([
          roleTypes.Super,
          roleTypes.Admin,
          roleTypes.Provider,
        ]),
        items: [
          {
            name: 'Zones',
            to: { name: 'RecoveriesByZone' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
              roleTypes.Provider,
            ]),
          },
          {
            name: 'Locations',
            to: { name: 'RecoveriesByLocation' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
              roleTypes.Provider,
            ]),
          },
          {
            name: 'Locations-Programs',
            to: { name: 'RecoveriesByLocationByProgram' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
              //roleTypes.Provider, // RMS-2192 temporarily removed from Provider role
            ]),
          },
          {
            name: 'Components',
            to: { name: 'RecoveriesByComponent' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
              roleTypes.Provider,
            ]),
          },
        ],
      },
      {
        name: 'Replenishments',
        icon: {
          name: 'truck',
          class: 'text-white fa-fw',
        },
        hidden: !user.methods.hasAnyRoles([roleTypes.Super, roleTypes.Admin]),
        items: [
          {
            name: 'Components',
            to: { name: 'ReplenishmentsByComponent' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
        ],
      },
      {
        name: 'Orders & BOLs',
        icon: {
          name: 'box-open',
          class: 'text-white fa-fw',
        },
        hidden: !user.methods.hasAnyRoles([
          roleTypes.Super,
          roleTypes.Admin,
          roleTypes.Provider,
          roleTypes.Customer,
        ]),
        items: [
          {
            name: 'Create Order',
            to: { name: 'OrderForms' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'BOLs',
            to: { name: 'LadingBills' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
              roleTypes.Provider,
              roleTypes.Customer,
            ]),
          },
          {
            name: 'Orders',
            to: { name: 'Orders' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
              // roleTypes.Provider, // per ticket RMS-1297, this is hidden for providers (for now)
              roleTypes.Customer,
            ]),
          },
          {
            name: 'Batch Files',
            to: { name: 'BatchFilesList' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
              roleTypes.Customer,
            ]),
          },
        ],
      },
      {
        name: 'Accounts',
        icon: {
          name: 'address-book',
          class: 'text-white fa-fw',
        },
        hidden: !user.methods.hasAnyRoles([roleTypes.Super, roleTypes.Admin]),
        items: [
          {
            name: 'Accounts',
            to: { name: 'Accounts' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Locations',
            to: { name: 'Locations' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          // {
          //   name: 'Contacts',
          //   to: { name: 'ComingSoon' },
          //   icon: ChevronRightIcon,
          //   current: false,
          //   hidden: !user.methods.hasAnyRoles([
          //     roleTypes.Super,
          //     roleTypes.Admin,
          //   ]),
          // },
        ],
      },
      {
        name: 'Account',
        icon: {
          name: 'address-book',
          class: 'text-white fa-fw',
        },
        hidden: !user.methods.hasAnyRoles([roleTypes.Provider, roleTypes.Customer]),
        items: [
          {
            name: 'My Account',
            to: { name: 'AccountInventoryLocationSummary', params: { code: user.methods.getAccount().code } },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([roleTypes.Provider, roleTypes.Customer]),
          },
          {
            name: 'My Locations',
            to: { name: 'Locations' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasRole(roleTypes.Provider),
          },
          {
            name: 'Account Locations',
            to: { name: 'Locations' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasRole(roleTypes.Customer),
          },
          {
            name: 'Authorized Locations',
            to: { name: 'AuthorizedLocations' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasRole(roleTypes.Customer),
          },
        ],
      },
      {
        name: 'Reports',
        icon: {
          name: 'chart-line',
          class: 'text-white fa-fw',
        },
        hidden: !user.methods.hasAnyRoles([
          roleTypes.Super,
          ...roleTypes.ReusabilitySet,
          roleTypes.Provider,
          roleTypes.Customer,
        ]),
        items: [
          {
            name: 'Order Details',
            to: { name: 'OrderItemsReport' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              ...roleTypes.ReusabilitySet,
              roleTypes.Provider,
              roleTypes.Customer,
            ]),
          },
          {
            name: 'Late Notifications',
            to: { name: 'lateNotificationsReport' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Pre-Billing',
            to: { name: 'PreBillingReport' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Completed Orders',
            to: { name: 'CompletedOrdersReport' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasRole(roleTypes.Provider),
          },
          {
            name: 'Invoicing',
            to: { name: 'InvoicingReport' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Ledger',
            to: { name: 'InventoryLedger' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Current Inventory By Location',
            to: { name: 'CurrentInventoryByLocation' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              ...roleTypes.ReusabilitySet,
              roleTypes.Provider,
              roleTypes.Customer,
            ]),
          },
          {
            name: 'Historical Inventory By Location', // MySQL
            to: { name: 'HistoricalInventoryByLocation' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              ...roleTypes.ReusabilitySet,
              roleTypes.Provider,
              roleTypes.Customer,
            ]),
          },
          {
            name: 'Cycle Count',
            to: { name: 'CycleCountReport' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Inventory Movements',
            to: { name: 'InventoryMovements' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Inventory By Stage', // formerly 'Inventory By Component'
            to: { name: 'InventoryByStage' }, // formerly 'InventoryByComponent'
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Inventory 99s',
            to: { name: 'InventoryLedger99Page' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Archive',
            to: { name: 'Reports' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              ...roleTypes.ReusabilitySet,
              roleTypes.Provider,
              roleTypes.Customer,
            ]),
          },
        ],
      },
      {
        name: 'Admin',
        icon: {
          name: 'gears',
          class: 'text-white fa-fw',
        },
        hidden: !user.methods.hasAnyRoles([roleTypes.Super, roleTypes.Admin]),
        items: [
          {
            name: 'Programs',
            to: { name: 'Program Management' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'SKU Management',
            to: { name: 'SkuManagement' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Plans',
            to: { name: 'PlanManagement' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Users',
            to: { name: 'Users' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasRole(roleTypes.Super),
          },
          {
            name: 'Master Adjustment',
            to: { name: 'MasterAdjustment' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasRole(roleTypes.Super),
          },
          {
            name: 'Call Priority Types',
            to: { name: 'CallPriorityTypes' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Week Numbers',
            to: { name: 'WeekNumbers' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Zones',
            to: { name: 'Zones' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
          {
            name: 'Imports',
            to: { name: 'Imports' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([roleTypes.Super, roleTypes.Admin]),
          },
          {
            name: 'Imported Files',
            to: { name: 'ImportFilesList' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([roleTypes.Super, roleTypes.Admin]),
          },
          {
            name: 'Tools',
            to: { name: 'Tools' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
            ]),
          },
          {
            name: 'Request Passport Token',
            to: { name: 'RequestTokenPage' },
            icon: ChevronRightIcon,
            current: false,
            hidden: !user.methods.hasAnyRoles([
              roleTypes.Super,
              roleTypes.Admin,
            ]),
          },
        ],
      },
      {
        name: 'Help',
        icon: {
          name: 'question',
          class: 'text-white fa-fw',
        },
        hidden: false,
        items: [
          {
            name: 'Help Files',
            to: { name: 'HelpFiles' },
            icon: ChevronRightIcon,
            current: false,
            hidden: false,
          },
        ],
      },
    ]
  },
  changeCurrentNav(itemMap) {
    state.items.forEach((tierOne) => {
      tierOne.current = tierOne.name === itemMap[0].name
      tierOne.items?.forEach((tierTwo) => {
        tierTwo.current =
          tierOne.name === itemMap[0].name && tierTwo.name === itemMap[1].name
        tierTwo.items?.forEach((tierThree) => {
          tierThree.current =
            tierOne.name === itemMap[0].name &&
            tierTwo.name === itemMap[1].name &&
            tierThree.name === itemMap[2].name
        })
      })
    })
  },
  getItems() {
    return state.items
  },
}

export default {
  name: 'NavigationStore',
  state: readonly(state),
  methods,
}
